import { useState, useEffect } from "react";
import {
  Search,
  Filter,
  ChevronDown,
  Clock10Icon,
  FilterIcon,
  FilterXIcon,
} from "lucide-react";
import {
  Dropdown,
  DatePicker,
  Drawer,
  Input,
  Select,
  TimePicker,
  Button,
} from "antd";
import IMAGES from "../../constants/images";
import { CalendarIcon } from "../../assets/images/svg";
import { MdOutlineSortByAlpha } from "react-icons/md";

import "./index.css";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import moment from "moment";
import { BsSortUpAlt } from "react-icons/bs";
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const { RangePicker } = DatePicker;
export default function AppointmentControls({
  selectedType,
  setSelectedType,
  setFilteredAppointment,
  filteredAppointment,
  selectedStatusProp,
  setSelectedStatusProp,
  selectedRows,
  onSortClick,
  activeTab,
}) {
  const [activeTypeTab, setActiveTypeTab] = useState(selectedType);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [isDesktopFilterOpen, setIsDesktopFilterOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("all");
  const [selectedTime, setSelectedTime] = useState(null);
  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);
  const [isAsc, setIsAsc] = useState(true); // new state for sort order
  let dropdownItems;
  if (activeTypeTab === "past") {
    dropdownItems = [
      { value: "all", label: "All" },

      { value: "COMPLETED", label: "Completed" },
      { value: "CANCELED", label: "Cancelled" },
      { value: "MISSED", label: "Missed" },
      { value: "INCOMPLETE", label: "Incomplete" },
      { value: "Unavailable", label: "Unavailable" },
    ];
  } else {
    dropdownItems = [
      { value: "all", label: "All" },
      { value: "SCHEDULED", label: "Upcoming" },
      { value: "COMPLETED", label: "Completed" },
      { value: "CANCELED", label: "Cancelled" },
      { value: "MISSED", label: "Missed" },
      { value: "INCOMPLETE", label: "Incomplete" },
      { value: "Unavailable", label: "Unavailable" },
    ];
  }

  const [bookingMode, setBookingMode] = useState([
    { label: "Audio Call", value: "AUDIO" },
    { label: "Video Call", value: "VIDEO" },
    { label: "Chat", value: "CHAT" },
    { label: "In-person", value: "INPERSON" },
  ]);
  const [bookingStatus, setBookingStatus] = useState([
    { label: "Upcoming", value: "SCHEDULED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Cancelled", value: "CANCELED" },
    { label: "In-Complete", value: "IN_COMPLETE" },
  ]);
  const [riskType, setRiskStatus] = useState([
    { label: "High", value: "HIGH_RISK" },
    { label: "Moderate", value: "MODERATE_RISK" },
    { label: "Low", value: "LOW_RISK" },
    { label: "No Risk", value: "NO_RISK" },
  ]);

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedMode, setSelectedMode] = useState([]);
  const [selectedRisk, setSelectedRisk] = useState([]);

  // Reset filters when switching between Appointments and Follow-ups tabs
  useEffect(() => {
    setSelectedItem("all");
    setSelectedDate(null);
    setSelectedStatus([]);
    setSelectedMode([]);
    setSelectedRisk([]);
    setFromTime(null);
    setToTime(null);
  }, [activeTab]);

  const searchText = (v) => {
    let clientData = Object.values(filteredAppointment || {}).flat();
    const filteredData = clientData.filter(
      (item) =>
        item.firstName.toLowerCase().includes(v.toLowerCase()) ||
        item.clientId.toLowerCase().includes(v.toLowerCase())
    );
    setFilteredAppointment(filteredData);
  };

  useEffect(() => {
    if (selectedStatus === null) {
    } else if (selectedStatus === "MISSED") {
      let clientData = Object.values(filteredAppointment || {}).flat();
      let filter = clientData.filter((item) => item.counsellorJoined === false);
      setFilteredAppointment(filter);
    }
  }, [selectedStatus]);

  // useEffect(() => {
  //   if (aid === "incomplete") {
  //     let clientData = Object.values(filteredAppointment || {}).flat();
  //     let filter = clientData.filter(
  //       (item) => item.url === null && item.status === "IN_COMPLETE"
  //     );
  //     console.log("filter===>", filter, clientData);
  //     setFilteredAppointment(filter);
  //   }
  // }, [aid]);

  const doDropDownFilter = (v) => {
    if (v === "all") {
      setFilteredAppointment(filteredAppointment);
    } else if (v === "INCOMPLETE") {
      let clientData = Object.values(filteredAppointment || {}).flat();
      let filter = clientData.filter((item) => item.status === "IN_COMPLETE");
      setFilteredAppointment(filter);
    } else if (v === "Unavailable") {
      let clientData = Object.values(filteredAppointment || {}).flat();
      let filter = clientData.filter(
        (item) => item.status === "COUNSELOR_UNAVAILABLE"
      );
      setFilteredAppointment(filter);
    } else if (v === "MISSED") {
      const now = moment();

      let clientData = Object.values(filteredAppointment || {}).flat();

      let filter = clientData.filter((item) => {
        const appointmentDateTime = moment(
          `${item.date} ${item.startTime}`,
          "YYYY-MM-DD HH:mm:ss"
        );

        const isTimePassed = appointmentDateTime.isBefore(now);
        const isStudentMissing =
          item.studentJoined === null || item.studentJoined === false;
        const isCounsellorMissing =
          item.counsellorJoined === null || item.counsellorJoined === false;

        return (
          (item.status === "SCHEDULED" ||
            item.status === "COUNSELOR_UNAVAILABLE") &&
          (isTimePassed || isStudentMissing || isCounsellorMissing)
        );
      });

      setFilteredAppointment(filter);
    } else {
      let clientData = Object.values(filteredAppointment || {}).flat();
      let filter = clientData.filter((item) => item.status === v);
      console.log("filter", filter, v);
      setFilteredAppointment(filter);
    }
  };

  const handleSort = () => {
    let clientData = Object.values(filteredAppointment || {}).flat();
    const combined = [...clientData].reverse();
    console.log("console====>", combined);
    setFilteredAppointment(combined);
  };

  const doDateFilter = (date) => {
    console.log(date);
    if (date === null || date === "") {
      setFilteredAppointment(filteredAppointment);
    } else {
      let clientData = Object.values(filteredAppointment || {}).flat();
      let filter = clientData.filter((item) => item.date === date);
      setFilteredAppointment(filter);
    }
  };

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-2 p-2">
        {/* Toggle Buttons */}
        <div className="flex justify-center items-center">
          <div className="inline-flex items-center gap-1 p-1 bg-white rounded-xl border-[1px] border-solid border-[#E2E8F0] shadow-sm">
            {["upcoming", "past"].map((tab) => (
              <button
                key={tab}
                onClick={() => {
                  setActiveTypeTab(tab);
                  setSelectedType(tab);
                }}
                className={`px-[12px] py-0 h-[30px] rounded-lg border-0 transition-all font-poppins font-semibold text-[12px] leading-[100%] ${
                  activeTypeTab === tab
                    ? "bg-[#0F172A] text-white shadow-md"
                    : "text-[#334155] bg-[#F8FAFC] hover:bg-gray-100"
                }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
          {selectedRows.length > 0 && (
            <>
              <span className="ml-2 font-poppins text-[#171717]">
                Selected Rows: {selectedRows.length}
              </span>
            </>
          )}
        </div>

        {/* Desktop Controls */}
        <div className="hidden md:flex items-center gap-3">
          {/* Search Input */}
          <div className="w-[300px]">
            <Input
              type="text"
              placeholder="Search by Patient Name / ID"
              onChange={(e) => searchText(e.target.value)}
              className="w-full h-9 px-4
                rounded-xl border-1
                border-[#E2E8F0] focus:ring-2 focus:ring-[#B3D7FF]
                text-[#64748B] bg-white shadow-sm
                font-normal text-sm
                font-poppins
                pl-[2px]
                placeholder:font-normal placeholder:text-sm placeholder:text-[#64748B] placeholder:font-poppins¯"
              prefix={
                <img
                  alt="search_icon"
                  src={IMAGES.search_icon}
                  className="w-5 h-5"
                />
              }
            />
          </div>

          {/* Dropdown */}
          <Select
            value={selectedItem}
            options={dropdownItems}
            onChange={(value) => {
              doDropDownFilter(value);
              setSelectedItem(value);
            }}
            className="w-[160px] h-9 font-poppins text-sm font-normal text-[#171717]"
            size="middle"
            rootclassName="custom-select-border"
          />

          {/* Date Picker */}
          <DatePicker
            onChange={(date, dateString) => {
              setSelectedDate(date);
              doDateFilter(dateString);
            }}
            placeholder="Select Date"
            className="h-9 rounded-xl border border-[#E2E8F0] shadow-sm px-3 text-[13px] w-36 font-poppins"
            suffixIcon={
              <CalendarIcon
                width={16}
                height={16}
                fill="#F1F5F9"
                stroke="#171717"
              />
            }
          />

          <button
            onClick={() => setIsDesktopFilterOpen(true)}
            className="flex items-center justify-center h-9 px-[14px] py-0 rounded-xl bg-white shadow-sm hover:bg-[#F8FAFC] transition"
            style={{ border: "1px solid #E2E8F0" }}
          >
            <span className="text-[#171717] text-[12px] font-semibold font-poppins">
              Filter
            </span>
            <img
              src={IMAGES.filter}
              alt="filter"
              size={18}
              className="text-[#2563EB] ml-1.5 w-4 h-4"
            />
          </button>
          <button
            onClick={onSortClick}
            className="flex items-center justify-center h-9 px-[14px] py-0 rounded-xl bg-white shadow-sm hover:bg-[#F8FAFC] transition"
            style={{ border: "1px solid #E2E8F0" }}
          >
            <span className="text-[#171717] text-[12px] font-semibold font-poppins mr-1.5">
              Sort
            </span>
            <MdOutlineSortByAlpha color={"#000000"} />
          </button>

          {/* Filter Button */}
          {/* <button className="flex items-center border border-[#CBD5E1] rounded-[8px] px-3 h-9">
            <Filter size={16} />
            <span className="ml-2 text-sm">Filter</span>
          </button> */}
        </div>

        {/* Mobile Controls */}
        <div className="flex md:hidden items-center gap-3">
          {/* Search Icon */}
          {/* <button
            onClick={() => setIsMobileSearchOpen(true)}
            className="flex items-center justify-center w-9 h-9 rounded-full bg-[#F1F5F9]"
          >
            <Search size={18} className="text-[#2563EB]" />
          </button> */}

          {/* Filter Icon */}

          <button
            onClick={() => setIsMobileFilterOpen(true)}
            className="flex items-center justify-center rounded-[8px] bg-[#F1F5F9]"
            style={{ border: "1px solid #E2E8F0" }}
          >
            <span className="text-[#171717] text-[14px] font-poppins">
              Filter
            </span>
            <img
              src={IMAGES.filter}
              alt="filter"
              size={18}
              className="text-[#2563EB] ml-1 w-4 h-4"
            />
          </button>
          {/* Example Checkbox */}
          {/* <input
            type="checkbox"
            className="w-4 h-4 border border-[#171717] rounded-sm"
          /> */}
        </div>
      </div>

      {/* Mobile Search Drawer */}
      <Drawer
        title="Search"
        placement="top"
        open={isMobileSearchOpen}
        onClose={() => setIsMobileSearchOpen(false)}
      >
        <div className="flex items-center border border-[#CBD5E1] rounded-[8px] px-2 h-9">
          <Search size={16} className="text-[#64748B]" />
          <input
            type="text"
            placeholder="Search by Patient Name / ID"
            className="ml-2 bg-transparent text-sm w-full focus:outline-none placeholder:text-[#94A3B8]"
          />
        </div>
      </Drawer>

      {/* Mobile Filter Drawer */}

      <Drawer
        title="Filter"
        placement="bottom"
        footer={
          <div className="flex justify-end gap-3">
            <button
              className="font-poppins text-[12px] text-[#4B61FF]  bg-[#ffffff]"
              style={{ border: "1px solid #4B61FF", borderRadius: "8px" }}
              onClick={() => {
                setIsMobileFilterOpen(false);
                setFilteredAppointment(filteredAppointment);
              }}
            >
              Cancel
            </button>
            <button
              className="font-poppins text-[14px] text-[#FFFFFF] btn-gradient rounded-xl"
              style={{ borderRadius: "8px" }}
              onClick={() => {
                const flatAppointments = Object.values(filteredAppointment || {}).flat();

                const filtered = flatAppointments.filter((appointment) => {
                  const modeMatch =
                    selectedMode.length === 0 ||
                    selectedMode.includes(appointment.mode);

                  const statusMatch =
                    selectedStatus.length === 0 ||
                    selectedStatus.includes(appointment.status);

                  const riskMatch =
                    selectedRisk.length === 0 ||
                    selectedRisk.includes(appointment.riskStatus);

                  const dateMatch =
                    !selectedDate ||
                    (Array.isArray(selectedDate) &&
                      selectedDate.length === 2 &&
                      dayjs(appointment.date)
                        .startOf("day")
                        .isBetween(
                          dayjs(selectedDate[0]).startOf("day"),
                          dayjs(selectedDate[1]).endOf("day"),
                          null,
                          "[]"
                        ));

                  const timeMatch =
                    (!fromTime && !toTime) ||
                    (dayjs(appointment.startTime, "HH:mm:ss").isSameOrAfter(
                      dayjs(fromTime, "HH:mm")
                    ) &&
                      dayjs(appointment.endTime, "HH:mm:ss").isSameOrBefore(
                        dayjs(toTime, "HH:mm")
                      ));

                  return (
                    modeMatch &&
                    statusMatch &&
                    riskMatch &&
                    dateMatch &&
                    timeMatch
                  );
                });

                console.log("Filtered appointments:", filtered);
                setFilteredAppointment(filtered);
                setIsMobileFilterOpen(false);
                setIsDesktopFilterOpen(false);
              }}
            >
              Apply Filter
            </button>
          </div>
        }
        open={isMobileFilterOpen}
        onClose={() => setIsMobileFilterOpen(false)}
        className="text-[24px] font-poppins text-[#171717]"
      >
        <div className="flex flex-col gap-2">
          {/* Date Picker */}
          <span className="text-[14px] text-[#171717] font-poppins">Date</span>
          <RangePicker
            onChange={(dates, dateStrings) => {
              setSelectedDate(dateStrings);
              console.log("Selected Moment objects:", dates);
              console.log("Selected date strings:", dateStrings);

              // setSelectedDates(dates);
              // setSelectedDateStrings(dateStrings);
            }}
            placeholder="Select Date"
            className="h-9 rounded-[8px] border-[#CBD5E1] px-2 text-[14px] text-[#171717] font-poppins"
            suffixIcon={
              <CalendarIcon
                width={16}
                height={16}
                fill={"#FFFFFF"}
                stroke={"#334155"}
              />
            }
          />
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Time Slot
          </span>
          <TimePicker
            onChange={(time, timeString) => setSelectedTime(timeString)}
            minuteStep={15}
            hourStep={1}
            secondStep={0}
            format="HH:mm"
            placeholder="Select Slot"
            className="h-9 rounded-[8px] border-[#CBD5E1] px-2 text-[14px] text-[#171717] font-poppins"
            suffixIcon={
              <Clock10Icon
                width={16}
                height={16}
                fill={"#FFFFFF"}
                stroke={"#334155"}
              />
            }
          />

          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Booking Mode
          </span>
          <div className="flex justify-between items-center mt-2">
            {bookingMode.map((item, index) => {
              const isSelected = selectedMode.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedMode((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Status
          </span>
          <div className="flex justify-between items-center mt-2">
            {bookingStatus.map((item, index) => {
              const isSelected = selectedStatus.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedStatus((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Risk Type
          </span>
          <div className="flex justify-between items-center mt-2">
            {riskType.map((item, index) => {
              const isSelected = selectedRisk.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedRisk((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
        </div>
      </Drawer>

      <Drawer
        title="Filter"
        placement="right"
        footer={
          <div className="flex justify-end gap-3">
            <button
              className="font-poppins text-[12px] text-[#4B61FF]  bg-[#ffffff]"
              style={{ border: "1px solid #4B61FF", borderRadius: "8px" }}
              onClick={() => {
                setIsDesktopFilterOpen(false);
                setFilteredAppointment(filteredAppointment);
              }}
            >
              Cancel
            </button>
            <button
              className="font-poppins text-[14px] text-[#FFFFFF] btn-gradient rounded-xl"
              style={{ borderRadius: "8px" }}
              onClick={() => {
                const flatAppointments = Object.values(filteredAppointment || {}).flat();

                const filtered = flatAppointments.filter((appointment) => {
                  const modeMatch =
                    selectedMode.length === 0 ||
                    selectedMode.includes(appointment.mode);

                  const statusMatch =
                    selectedStatus.length === 0 ||
                    selectedStatus.includes(appointment.status);

                  const riskMatch =
                    selectedRisk.length === 0 ||
                    selectedRisk.includes(appointment.riskStatus);

                  const dateMatch =
                    !selectedDate ||
                    (Array.isArray(selectedDate) &&
                      selectedDate.length === 2 &&
                      dayjs(appointment.date)
                        .startOf("day")
                        .isBetween(
                          dayjs(selectedDate[0]).startOf("day"),
                          dayjs(selectedDate[1]).endOf("day"),
                          null,
                          "[]"
                        ));

                  const timeMatch =
                    (!fromTime && !toTime) ||
                    (dayjs(appointment.startTime, "HH:mm:ss").isSameOrAfter(
                      dayjs(fromTime, "HH:mm")
                    ) &&
                      dayjs(appointment.endTime, "HH:mm:ss").isSameOrBefore(
                        dayjs(toTime, "HH:mm")
                      ));

                  return (
                    modeMatch &&
                    statusMatch &&
                    riskMatch &&
                    dateMatch &&
                    timeMatch
                  );
                });

                console.log("Filtered appointments:", filtered);
                setFilteredAppointment(filtered);
                setIsMobileFilterOpen(false);
                setIsDesktopFilterOpen(false);
              }}
            >
              Apply Filter
            </button>
          </div>
        }
        open={isDesktopFilterOpen}
        onClose={() => setIsDesktopFilterOpen(false)}
        className="text-[24px] font-poppins text-[#171717]"
      >
        <div className="flex flex-col gap-2">
          {/* Date Picker */}
          <span className="text-[14px] text-[#171717] font-poppins">Date</span>
          <RangePicker
            onChange={(dates, dateStrings) => {
              setSelectedDate(dateStrings);
              console.log("Selected Moment objects:", dates);
              console.log("Selected date strings:", dateStrings);

              // setSelectedDates(dates);
              // setSelectedDateStrings(dateStrings);
            }}
            placeholder="Select Date"
            className="h-9 rounded-[8px] border-[#CBD5E1] px-2 text-[14px] text-[#171717] font-poppins"
            suffixIcon={
              <CalendarIcon
                width={16}
                height={16}
                fill={"#FFFFFF"}
                stroke={"#334155"}
              />
            }
          />
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <div className="flex justify-between">
            <div className="w-[45%]">
              <span className="text-[14px] text-[#171717] font-poppins mt-2">
                From Time Slot
              </span>
              <TimePicker
                style={{ width: "100%" }}
                onChange={(time, timeString) => setFromTime(timeString)}
                minuteStep={15}
                hourStep={1}
                secondStep={0}
                format="HH:mm"
                placeholder="Select Slot"
                className="h-9 rounded-[8px] border-[#CBD5E1] px-2 text-[14px] text-[#171717] font-poppins"
                suffixIcon={
                  <Clock10Icon
                    width={16}
                    height={16}
                    fill={"#FFFFFF"}
                    stroke={"#334155"}
                  />
                }
              />
            </div>
            <div className="w-[45%]">
              <span className="text-[14px] text-[#171717] font-poppins mt-2">
                To Time Slot
              </span>
              <TimePicker
                style={{ width: "100%" }}
                onChange={(time, timeString) => setToTime(timeString)}
                minuteStep={15}
                hourStep={1}
                secondStep={0}
                format="HH:mm"
                placeholder="Select Slot"
                className="h-9 rounded-[8px] border-[#CBD5E1] px-2 text-[14px] text-[#171717] font-poppins"
                suffixIcon={
                  <Clock10Icon
                    width={16}
                    height={16}
                    fill={"#FFFFFF"}
                    stroke={"#334155"}
                  />
                }
              />
            </div>
          </div>
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Booking Mode
          </span>
          <div className="flex justify-between items-center mt-2">
            {bookingMode.map((item, index) => {
              const isSelected = selectedMode.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedMode((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Status
          </span>
          <div className="flex justify-between items-center mt-2">
            {bookingStatus.map((item, index) => {
              const isSelected = selectedStatus.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedStatus((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
          <div className="w-full h-[0.5px] bg-gray-200 mb-0 mt-4"></div>
          <span className="text-[14px] text-[#171717] font-poppins mt-2">
            Risk Type
          </span>
          <div className="flex justify-between items-center mt-2">
            {riskType.map((item, index) => {
              const isSelected = selectedRisk.includes(item.value);
              console.log(isSelected);
              return (
                <Button
                  className={`text-[10px] border-0   font-poppins ${
                    isSelected
                      ? `bg-[#2563EB] text-[#FFFFFF]`
                      : `bg-[#EFF6FF] text-[#334155]`
                  }`}
                  onClick={() => {
                    setSelectedRisk((prev) =>
                      isSelected
                        ? prev.filter((v) => v !== item.value)
                        : [...prev, item.value]
                    );
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </div>
        </div>
      </Drawer>
    </>
  );
}
